import { ArrowRightOutlined } from '@ant-design/icons';
import { Heading } from '@mm/components';
import { CloseIcon } from '@mm/icons';
import { useResolutionInfo } from '@mm/hooks';
import facebookAudienceExtractorBanner from 'assets/slideout-banners/facebook-audience-extractor-banner_black.png';
import facebookAudienceExtractorBannerMobile from 'assets/slideout-banners/facebook-audience-extractor-banner-mobile.png';
import instagramAudienceExtractorBanner from 'assets/slideout-banners/instagram-audience-extractor-banner_black.png';
import instagramAudienceExtractorBannerMobile from 'assets/slideout-banners/instagram-audience-extractor-banner-mobile.png';
import React from 'react';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';
import { ModalInstanceProps } from '../interfaces';
import styles from './AudienceExtractorModal.module.css';

type Props = ModalInstanceProps & {
  channel: 'instagram' | 'facebook';
};

export const AudienceExtractorModal = (props: Props) => {
  const { channel, closeModal } = props;
  const { screenWidth } = useResolutionInfo();

  let bannerSrc;
  let channelName;
  switch (channel) {
    case 'instagram':
      bannerSrc =
        screenWidth > 830
          ? instagramAudienceExtractorBanner
          : instagramAudienceExtractorBannerMobile;
      channelName = 'Instagram';
      break;
    case 'facebook':
    default:
      bannerSrc =
        screenWidth > 830
          ? facebookAudienceExtractorBanner
          : facebookAudienceExtractorBannerMobile;
      channelName = 'Facebook';
  }

  return (
    <div className={styles.container}>
      <div className={styles.badgeContainer}>
        <div className={styles.badge}>
          <div className={styles.badgeRow2}>#1 </div>
          <div className={styles.badgeRow3}>ENGAGEMENT TOOL</div>
        </div>
        <div className={styles.badgeTriangle} />
      </div>
      <CloseIcon
        color="#8c8c8c"
        className={styles.closeIcon}
        onClick={() => closeModal()}
      />
      <div className={styles.description}>
        <div className={styles.aboveHeading}>We activated your</div>
        <Heading size={2} className={styles.heading}>
          {channelName} Audience Extractor
        </Heading>
        <div className={styles.subHeading}>
          Our Famous {channelName} Audience Extractor follows up on all{' '}
          {channelName}&nbsp; engagement and attempts to collect phone numbers
          and email addresses.
        </div>
        <PrimaryButton className={styles.button} onClick={() => closeModal()}>
          <ArrowRightOutlined className={styles.arrowIcon} />
          Got it
        </PrimaryButton>
      </div>
      <img className={styles.bannerImage} src={bannerSrc} />
    </div>
  );
};
